var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "columns pt-2" }, [
      _c(
        "div",
        { staticClass: "mt-6 column", attrs: { id: "settings-container" } },
        [
          !_vm.openSidebar
            ? _c(
                "b-button",
                {
                  staticClass: "mb-4",
                  attrs: { "icon-left": "angle-left" },
                  on: { click: _vm.setOpenSidebar },
                },
                [_vm._v("Regresar")]
              )
            : _vm._e(),
          _c("div", { staticClass: "is-flex" }, [
            _c(
              "div",
              {
                class: [
                  _vm.openSidebar
                    ? "sidebar-section"
                    : "sidebar-section-display-none",
                ],
              },
              [
                _c(
                  "div",
                  { staticClass: "card-item" },
                  [
                    _c("h2", { staticClass: "pl-4 is-size-4" }, [
                      _vm._v(_vm._s(_vm.$t("settings.title"))),
                    ]),
                    _c("SecondarySidebar", {
                      attrs: {
                        "open-sidebar": _vm.openSidebar,
                        options: _vm.options,
                        "section-active": _vm.sectionActive,
                      },
                      on: {
                        sectionActive: _vm.setActiveSection,
                        openSidebar: _vm.setOpenSidebar,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            !_vm.openSidebar || _vm.shouldSettingContentBeSeen
              ? _c(
                  "div",
                  {
                    class: [
                      _vm.openSidebar
                        ? "is-flex-grow-2 setting-content ml-4"
                        : "is-flex-grow-2 setting-content",
                    ],
                  },
                  [
                    _c("div", [
                      _vm.sectionActive == 0
                        ? _c(
                            "div",
                            [
                              _vm.$i18n.locale === "cl"
                                ? _c("FeaturesToggles")
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.sectionActive == 1
                        ? _c(
                            "div",
                            [
                              _c("UsersPermissions", {
                                attrs: { restart: _vm.restartComponents },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.sectionActive == 2
                        ? _c(
                            "div",
                            [
                              _c("Sections", {
                                on: {
                                  sectionUpdate: _vm.refreshSectionUserFeatures,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.sectionActive == 3
                        ? _c("div", [_c("RiskPolicy")], 1)
                        : _vm._e(),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }